import FirebaseContext, { AuthUserContext } from './context';
import Firebase from './Firebase';
export default Firebase;
export { FirebaseContext, AuthUserContext };
